export class HttpError extends Error {
  status: number;

  body: string;

  constructor(status: number, body: string) {
    super(`HTTP Error ${status}`);
    this.status = status;
    this.body = body;
  }
}

export default async function checkResStatus(res: Response): Promise<unknown> {
  if (res.status === 204) {
    return undefined;
  }
  if (res.ok) {
    const text = await res.text();
    if (!text) {
      return undefined;
    }
    try {
      return JSON.parse(text);
    } catch {
      return undefined;
    }
  }
  const body = await res.text();
  throw new HttpError(res.status, body);
}
